import React from "react";
import classNames from "classnames";

import { useTranslation } from "react-i18next";
import { DetailsViews } from "../../api/views";
import { Context } from "../../context";
import { Props } from "./types";
import styles from "./styles.scss";

function DetailsViewSelector(_: Props) {
  const { t } = useTranslation();
  const { detailsView, selectDetailsView } = React.useContext(Context);

  return (
    <div className={styles.detailsViewSelector}>
      <button
        className={classNames(styles.toggleButton, {
          [styles.pressed]: detailsView === DetailsViews.DATES,
        })}
        onClick={() => selectDetailsView(DetailsViews.DATES)}
      >
        {t("gantt.details.views.dates")}
      </button>
      <button
        className={classNames(styles.toggleButton, {
          [styles.pressed]: detailsView === DetailsViews.PROGRESS,
        })}
        onClick={() => selectDetailsView(DetailsViews.PROGRESS)}
      >
        {t("gantt.details.views.progress")}
      </button>
    </div>
  );
}

export { DetailsViewSelector };
